import React, { useEffect } from "react";

import { useDispatch } from "react-redux";

import {
  BaseUrlCore,
  messageApi,
  simReportApi,
  simReportPdfApi,
} from "../../../utility/api/apiList";

import { showModalAlert } from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";

import ActivityModal from "../../../components/public/singleSimTabs/activityTab/modal";
import ActivityTab from "../../../components/public/singleSimTabs/activityTab";
import { useLocation } from "react-router-dom";

const ActivityTabContainer = ({
  simID,
  isLoaded,
  editorContent,
  simReportData,
  uploaderImageArray,
  setLabReportSection,
}) => {
  const qs = require("qs");
  const qsData = qs.stringify({
    downlod: "true",
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const editFromProfile = location.state?.editFromProfile;
  const reportID = location.state?.reportID;

  const {
    data: labReportData,
    isLoaded: labReportDataIsLoaded,
    error: labReportError,
    run: labReportDataRun,
  } = useAxios({
    url: `${simReportApi}${editFromProfile ? reportID : simReportData?.id}/`,
    params: {
      type: "self",
    },
  });

  const { isLoading: loadingDownloadPdf, run: downloadPdf } = useAxios({
    config: {
      method: "get",
      url: `${simReportPdfApi}${simID}/`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      responseType: "blob",
      configData: qsData,
    },
  });

  const { isLoading: checkTeacherIdIsLoading, run: checkTeacherIdRun } = useAxios({
    baseURL: BaseUrlCore,
  });

  const { isLoading: sendActivityIsLoading, run: sendActivityRun } = useAxios({
    url: messageApi,
    method: "post",
  });

  useEffect(() => {
    labReportDataRun();
  }, []);

  const openSendActivityModal = () => {
    dispatch(
      showModalAlert({
        maxWidth: "497px",
        backdrop: true,
        content: (
          <ActivityModal
            simReportData={simReportData}
            loading={{ checkTeacherIdIsLoading, sendActivityIsLoading }}
            activityMessageRun={{ sendActivityRun, checkTeacherIdRun }}
          />
        ),
      })
    );
  };

  return (
    <ActivityTab
      downloadPdf={downloadPdf}
      editorContent={editorContent}
      simReportData={labReportData}
      error={labReportError}
      isLoaded={isLoaded || labReportDataIsLoaded}
      uploadedImages={uploaderImageArray}
      setLabReportSection={setLabReportSection}
      openSendActivityModal={openSendActivityModal}
      loading={loadingDownloadPdf}
    />
  );
};

export default ActivityTabContainer;
